<template>
  <div v-if="editMode">
    <div class="field-row">
      <label>
        <input type="checkbox" v-model="field.includeDate" />
        Include Date
      </label>

      <label style="margin-left: 15px;">
        <input type="checkbox" v-model="field.includeTime" />
        Include Time
      </label>
    </div>

    <div class="field-row">
      <label>
        <input type="checkbox" v-model="field.required" />
        Required
      </label>
    </div>
  </div>
  <div v-else>
    <div class="vf-field-label">{{ field.fieldName }}</div>
  </div>
</template>

<script>
  export default {
    name: 'DateTimeField',
    props: {
      field: {
        type: Object,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false
      },
    },
    mounted() {
      // Set default values if not already set
      if (this.field.includeDate === undefined) {
        this.field.includeDate = true;
      }
      if (this.field.includeTime === undefined) {
        this.field.includeTime = false;
      }
    },
    data() {
      return {
        // Add your component data here
      };
    },
    methods: {
      // Add your component methods here
    },
  };
</script>

<style scoped>
  label {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  label input[type="checkbox"] {
    margin-right: 5px;
  }
</style>
